import React, { useState, useEffect, useCallback } from "react";
import {
  TextField,
  Button,
  MenuItem,
  Typography,
  Paper,
  Box,
  Stack,
  Grid,
} from "@mui/material";
import { Toaster, toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import * as services from "./../../services/services";
import AppBreadcrumbs from "./../../components/AppBreadcrumbs";
import { IconButton, InputAdornment } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { jwtDecode } from "jwt-decode";

export default function CreateUser() {
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("accessToken");
  const decoded = jwtDecode(accessToken);

  const [showPassword, setShowPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);

  const [imagePreview, setImagePreview] = useState(null);
  const [hospitals, setHospital] = useState([]);

  const [form, setForm] = useState({
    username: "",
    password: "",
    rePassword: "",
    name: "",
    lastname: "",
    title: "",
    phoneNumber: "",
    idCard: "",
    license_no: "",
    image: "",
    hospitalId: decoded.hospitalId,
    roleId: 2,
  });

  const fetchHospital = useCallback(async () => {
    const res = await services.getHospitalList();
    setHospital(res.data.data);
  }, []);

  useEffect(() => {
    fetchHospital();
  }, [fetchHospital]);

  const handleChange = async (e) => {
    const { name, value, files } = e.target;

    if (name === "image" && files && files[0]) {
      const file = files[0];

      setImagePreview(URL.createObjectURL(file));

      try {
        const res = await services.uploadImage(file);
        const imageUrl = res.data;
        setForm({ ...form, image: imageUrl[0] });
      } catch (err) {
        toast.error("Upload รูปไม่สำเร็จ");
      }

      return;
    }

    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(form.username)) {
      toast.error("รูปแบบอีเมลไม่ถูกต้อง");
      return;
    }

    if (form.password !== form.rePassword) {
      toast.error("รหัสผ่านไม่ตรงกัน!");
      return;
    }

    if (form.password.length < 8) {
      toast.error("รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร");
      return;
    }

    try {
      const res = await services.register(form);

      if (!res.data.success) throw new Error();

      toast.success("เพิ่มบุคลากรสำเร็จ!");
      navigate("/users");
    } catch (error) {
      toast.error("เพิ่มบุคลากรไม่สำเร็จ Username นี้ถูกใช้งานแล้ว");
    }
  };

  return (
    <>
      <AppBreadcrumbs />
      <Toaster position="bottom-left" />

      <Box sx={{ maxWidth: 900, mx: "auto", mt: 3 }}>
        <Paper
          elevation={3}
          sx={{
            p: 4,
            borderRadius: 3,
          }}
        >
          <Typography variant="h5" fontWeight={600} mb={3}>
            เพิ่มบุคลากร
          </Typography>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "1fr 2fr" },
              gap: 4,
            }}
          >
            {/* ซ้าย รูป */}

            <Box
              sx={{
                border: "2px dashed #ddd",
                borderRadius: 3,
                p: 2,
                textAlign: "center",
                cursor: "pointer",
                minHeight: 250,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#fafafa",
              }}
              onClick={() =>
                document.getElementById("user-image-upload")?.click()
              }
            >
              {imagePreview ? (
                <img
                  src={imagePreview}
                  alt="preview"
                  style={{
                    width: 160,
                    height: 160,
                    objectFit: "cover",
                    borderRadius: "12px",
                  }}
                />
              ) : (
                <Typography color="text.secondary">
                  คลิกเพื่ออัปโหลดรูป
                </Typography>
              )}

              <input
                id="user-image-upload"
                type="file"
                hidden
                accept="image/*"
                name="image"
                onChange={handleChange}
              />
            </Box>

            {/* ขวา form */}

            <Box>
              <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      label="Email"
                      name="username"
                      value={form.username}
                      onChange={handleChange}
                      fullWidth
                      required
                    />
                  </Grid>

                  {/* PASSWORD */}

                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Password"
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={form.password}
                      onChange={handleChange}
                      fullWidth
                      required
                      error={
                        form.password.length > 0 && form.password.length < 8
                      }
                      helperText={
                        form.password.length > 0 && form.password.length < 8
                          ? "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร"
                          : ""
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword(!showPassword)}
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Re-Password"
                      type={showRePassword ? "text" : "password"}
                      name="rePassword"
                      value={form.rePassword}
                      onChange={handleChange}
                      fullWidth
                      required
                      error={
                        form.rePassword.length > 0 &&
                        form.password !== form.rePassword
                      }
                      helperText={
                        form.rePassword.length > 0 &&
                        form.password !== form.rePassword
                          ? "รหัสผ่านไม่ตรงกัน"
                          : ""
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowRePassword(!showRePassword)}
                            >
                              {showRePassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>

                  {/* NAME */}

                  <Grid item xs={12} md={4}>
                    <TextField
                      label="คำนำหน้า"
                      name="title"
                      value={form.title}
                      onChange={handleChange}
                      fullWidth
                      required
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      label="ชื่อ"
                      name="name"
                      value={form.name}
                      onChange={handleChange}
                      fullWidth
                      required
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      label="นามสกุล"
                      name="lastname"
                      value={form.lastname}
                      onChange={handleChange}
                      fullWidth
                      required
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      label="เบอร์โทรศัพท์"
                      name="phoneNumber"
                      value={form.phoneNumber}
                      onChange={handleChange}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      label="เลขบัตรประชาชน"
                      name="idCard"
                      value={form.idCard}
                      onChange={handleChange}
                      fullWidth
                      required
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      label="เลขที่ใบอนุญาต"
                      name="license_no"
                      value={form.license_no}
                      onChange={handleChange}
                      fullWidth
                      required
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      select
                      label="สังกัดโรงพยาบาล"
                      name="hospitalId"
                      value={form.hospitalId}
                      onChange={handleChange}
                      fullWidth
                      disabled
                    >
                      {hospitals.map((h) => (
                        <MenuItem key={h.id} value={h.id}>
                          {h.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid item xs={12}>
                    <Box display="flex" gap={2}>
                      <Button
                        variant="outlined"
                        onClick={() => navigate("/users")}
                      >
                        ยกเลิก
                      </Button>

                      <Button type="submit" variant="contained">
                        เพิ่มบุคลากร
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </form>
            </Box>
          </Box>
        </Paper>
      </Box>
    </>
  );
}
